import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function SocialLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    if (user.role === "social") return <Navigate to="/setor-social/painel" replace />;
    if (user.role === "admin") return <Navigate to="/setor-social/painel" replace />;
    return <Navigate to="/" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vinda!");
      nav("/setor-social/painel");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div data-testid="social-login-page" className="min-h-[80vh] flex items-center justify-center py-20 px-6">
      <form onSubmit={onSubmit} className="w-full max-w-md bg-white border border-cream-400 p-10">
        <div className="w-12 h-12 rounded-full bg-forest-700 text-cream-100 flex items-center justify-center mx-auto mb-4">
          <Heart className="w-5 h-5" />
        </div>
        <h1 className="font-display text-3xl text-forest-900 text-center">Setor Social</h1>
        <p className="text-center text-forest-900/70 mt-2 text-sm">Acesso restrito · Responsável: Elen Samara</p>

        <label className="block mt-8">
          <span className="text-xs uppercase tracking-[0.18em] text-forest-900/70 font-medium">E-mail</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="social-login-email"
            className="mt-2 w-full bg-cream-100 border border-cream-400 focus:border-forest-700 focus:outline-none p-3.5" />
        </label>
        <label className="block mt-4">
          <span className="text-xs uppercase tracking-[0.18em] text-forest-900/70 font-medium">Senha</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="social-login-password"
            className="mt-2 w-full bg-cream-100 border border-cream-400 focus:border-forest-700 focus:outline-none p-3.5" />
        </label>
        <button type="submit" disabled={loading} data-testid="social-login-submit" className="btn-primary w-full mt-8">
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
